import React, { useEffect, useState } from "react";
import { SelectList } from "components/table/DataTable/Fields";
import { SelectItem } from "components/forms/Select";
import InlineInputGroup from "components/forms/FormFields/InlineInputGroup";
import strings from "localisation/strings";
import { AlertNotificationSeverity } from "api/models/AlertNotificationInterface";
import styled from "styled-components";
import FieldErrors from "components/forms/FieldErrors";

interface AlertNotificationsDropdownProps {
  onChange: (selectedField: any, selectedValue: any) => void;
  isPublishAlert: boolean;
  getErrors: (field: any) => string[];
  value?: AlertNotificationSeverity;
}

const ErrorContainer = styled.div`
  width: 100%;
  margin-left: ${({ theme }) => theme.forms.leftSide};
`;

const options: SelectItem[] = [
  {
    value: AlertNotificationSeverity.info,
    label: strings("postsScreen.fields.alertNotificationSeverity.info.label"),
  },
  {
    value: AlertNotificationSeverity.warning,
    label: strings(
      "postsScreen.fields.alertNotificationSeverity.warning.label",
    ),
  },
  {
    value: AlertNotificationSeverity.important,
    label: strings(
      "postsScreen.fields.alertNotificationSeverity.important.label",
    ),
  },
  {
    value: AlertNotificationSeverity.importantDetailed,
    label: strings(
      "postsScreen.fields.alertNotificationSeverity.importantDetailed.label",
    ),
  },
];

const AlertNotificationsDropdown = ({
  onChange,
  isPublishAlert,
  getErrors,
  value,
}: AlertNotificationsDropdownProps) => {
  const [selectedNotification, setSelectedNotification] = useState<
    SelectItem
  >();

  useEffect(() => {
    if (!isPublishAlert) {
      onChange("alertNotificationSeverity", null);
      setSelectedNotification(undefined);
    } else {
      if (value) {
        const option = options.find(option => option.value === value);
        setSelectedNotification(option);
      }
    }
  }, [isPublishAlert, value]);

  const handleSelectionChange = (option: SelectItem) => {
    setSelectedNotification(option);
    onChange("alertNotificationSeverity", option.value);
  };

  return isPublishAlert ? (
    <>
      <InlineInputGroup>
        <SelectList
          options={options}
          onChange={handleSelectionChange}
          placeholder={strings(
            "postsScreen.fields.alertNotificationSeverity.placeholder",
          )}
          width="350px"
          classNamePrefix="option"
          value={selectedNotification}
        />
      </InlineInputGroup>
      {getErrors("alertNotificationSeverity") && (
        <ErrorContainer>
          <FieldErrors errors={getErrors("alertNotificationSeverity")} />
        </ErrorContainer>
      )}
    </>
  ) : null;
};

export default AlertNotificationsDropdown;
